import { TableCell } from "@mui/material"
import { convertCellToTextOrDate } from "./convert-cell-to-text-or-date"

export function PreviewCell({ item, row }) {
    let cellContent = convertCellToTextOrDate(row, item)
    return <TableCell>{cellContent}</TableCell>
}
